import { render } from "./UnitDetail.vue?vue&type=template&id=22d5c34d"
import script from "./UnitDetail.vue?vue&type=script&lang=js"
export * from "./UnitDetail.vue?vue&type=script&lang=js"

import "./UnitDetail.vue?vue&type=style&index=0&id=22d5c34d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__